module.exports = __webpack_public_path__ + "static/media/stability.00895610.svg";